module.exports = __webpack_public_path__ + "static/Grupo535-4fe338d027b97f752ae4eecbbf61aaa0.png";